export default {
  HANDBACK: 'handback',
};
